import {getInfo, login, loginByWx, logout, register, weichatLogin} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'
import cache from '@/plugins/cache'

const user = {
    state: {
        token: getToken(),
        userInfo: {},
        name: '',
        avatar: '',
        roles: [],
        permissions: [],
        nickName: '',
        manager: false,
        loginToken: '',
        environmentType: '1'
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_LOGIN_TOKEN: (state, loginToken) => {
            state.loginToken = loginToken
        },
        SET_MANAGER: (state, token) => {
            state.manager = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        },
        SET_NICKNAME: (state, nickName) => {
            state.nickName = nickName
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
        },
        SET_ENVIRONMENT_TYPE: (state, environmentType) => {
            state.environmentType = environmentType
        },
    },

    actions: {
        // 企业微信账号获取登录权限
        LoginByWx({commit}, info) {
            return new Promise((resolve, reject) => {
                loginByWx(info).then(res => {
                    setToken(res.token)
                    commit('SET_TOKEN', res.token)
                    commit('SET_USER_INFO', res.user) // 解析token获取用户信息
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登录
        Login({commit}, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password
            const code = userInfo.code
            const uuid = userInfo.uuid
            return new Promise((resolve, reject) => {
                login(username, password, code, uuid).then(res => {
                    setToken(res.token)
                    commit('SET_TOKEN', res.data)
                    commit('SET_MANAGER', res.manager)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        Register({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                register(userInfo).then(res => {
                    setToken(res.token)
                    commit('SET_TOKEN', res.token)
                    commit('SET_MANAGER', res.manager)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        WeChatLogin({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                weichatLogin(userInfo).then(res => {
                    if (res.hasUser) {
                        setToken(res.token)
                        commit('SET_TOKEN', res.token)
                        commit('SET_MANAGER', res.manager)
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },


        /**
         * 描述信息
         * @author ConFront_C_Eng
         * @date 2023-09-28 08:53:39
         */
        GetInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    var avatar = localStorage.getItem('avatar')
                    res.user.avatar = avatar
                    console.log('--user-----getInfo------', res)
                    cache.session.set("userInfo", JSON.stringify(res.user))
                    cache.session.set("permissions", JSON.stringify(res.permissions))
                    commit('SET_USER_INFO', res.user)
                    if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
                        commit('SET_ROLES', res.roles)
                        commit('SET_PERMISSIONS', res.permissions)
                    } else {
                        commit('SET_ROLES', ['ROLE_DEFAULT'])
                    }
                    commit('SET_NAME', res.user.userName)
                    commit('SET_NICKNAME', res.user.nickName)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退出系统
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_MANAGER', '')
                    commit('SET_ROLES', [])
                    commit('SET_PERMISSIONS', [])
                    cache.session.remove("userInfo")
                    cache.session.remove("sessionObj")
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                commit('SET_MANAGER', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user
